import API from '../../../lib/commons/api'

export type UserDto = {
  uuid: string
  name: string
  code: string
  iconUrl: string
}

// Fetch-all uses a high limit so every record comes back in a single request.
const FIND_ALL_LIMIT = 2000

export const findUsers = async (): Promise<UserDto[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/users/find',
    { validOnly: false, limit: FIND_ALL_LIMIT },
    true
  )
  return (response.json?.data ?? []) as UserDto[]
}
